import { P2TextDescription } from 'react-bootstrap-common-script'

function CompletionReminderSegment() {
  return (
    <div className='polymer-stage-e-reminder px-4 pb-4'>
      <P2TextDescription color='#333' title={'Items to note before completion'} description={'Please take note of the following when preparing for your completion appointment.'} />
    </div>
  )
}

export default CompletionReminderSegment